<template>
  <div class="buttonContainer">
    <button
    v-for="option in optionList"
    :key="option.value"
    class="btn buttonOption"
    :style="returnBgColor(option)"
    :disabled="clickDisabled"
    @click="onOptionSelect(option)">
      <span v-html="option.label"></span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ToggleSwitch',
  props: {
    /** EXAMPLE OPTION
     * optionList: {
     *   heavy: {
     *     id: 1,
     *     label: this.$t('OrderCurrent.modal.heavy'),
     *     value: 'Heavy',
     *     selected: false
     *   },
     *   medium: {
     *     [...]
     *   }
     * }
     * Make sure to include @emitOptionList in the <toggle-switch> tag
     */
    optionList: {
      type: Object,
      required: true
    },

    multiple: {
      type: Boolean,
      required: false,
      default: false
    },

    clickDisabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  created () {
    this.emitOptionList()
  },

  methods: {
    onOptionSelect (selectedOption) {
      this.processOption(selectedOption)

      if (this.multiple) this.emitOptionList()
      else this.emitSelectedOption()
    },

    updateOption (selectedOption) {
      this.processOption(selectedOption)
    },

    /** Some usages of the component allows multiple selection or not, do that thang 21 */
    processOption (selectedOption) {
      for (const option in this.optionList) {
        if (Object.hasOwnProperty.call(this.optionList, option)) {
          let optionObj = this.optionList[option]

          if (!this.multiple && optionObj.id !== selectedOption.id) optionObj.selected = false
          else if (this.multiple && optionObj.id === selectedOption.id) optionObj.selected = !optionObj.selected
          else if (optionObj.id === selectedOption.id) optionObj.selected = true
        }
      }
    },

    /** Emit the whole option list if the component allows multiple selection */
    emitOptionList () {
      this.$emit('emitOptionList', this.optionList)
    },

    /** Only emit the option where @selected is true if the component only allows single selection */
    emitSelectedOption () {
      for (const option in this.optionList) {
        if (Object.hasOwnProperty.call(this.optionList, option)) {
          const optionObj = this.optionList[option]

          if (optionObj.selected) this.$emit('emitSelectedOption', optionObj)
        }
      }
    },

    returnBgColor (option) {
      let color = ''
      if (option.selected) color = option.selectedBgColor
      else color = option.bgColor

      return {
        'background-color': color
      }
    }
  }
}
</script>

<style scoped>
  .buttonContainer {
    display: flex;
  }

  .selectedOption {
    background-color: rgb(30, 180, 255, 0.8) !important;
  }

  .buttonOption {
    border-radius: 2px;
  }
</style>
